export default __webpack_public_path__ + "static/media/northernHackers.ffe0686b.png";